var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BootstrapTable',{ref:"table",attrs:{"data":_vm.racks,"columns":_vm.tableColumns,"options":_vm.tableOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }